import { PATH } from '../constants/path';
import { DEFAULT_LOCALE } from '../constants/locale';

/**
 * Return the begin of the directory url
 * @param {*String} locale  : current locale
 * @param {*String} defaultLocale: default locale of project
 * @param {*Boolean} isCodePromo : codepromo directory ?
 * @param {*Boolean} isOffline : offline directory ?
 * @param {*Boolean} isEbon : ebon directory ?
 */
export const buildPathPrefixWithDefaultLocale = (locale, isCodePromo, isOffline, isEbon) =>
    ''.concat(
        locale && locale !== DEFAULT_LOCALE ? `/${locale}` : '',
        isCodePromo
            ? PATH.REDUCTION_PATH
            : isOffline
            ? PATH.CASHBACK_OFFLINE
            : isEbon
            ? PATH.CASHBACK_EBON
            : PATH.CASHBACK_ONLINE
    );

/**
 * Return the begin of the directory url
 * @param {*String} locale  : current locale
 * @param {*Boolean} isCodePromo : codepromo directory ?.
 * @param {*Boolean} isOffline : offline directory ?
 * @param {*Boolean} isEbon : ebon directory ?
 */
export const buildPathPrefix = (locale, isCodePromo, isOffline, isEbon) =>
    buildPathPrefixWithDefaultLocale(locale, isCodePromo, isOffline, isEbon);



// WEBPACK FOOTER //
// ./src/utils/directoryUtils.js